import * as React from 'react';

import { ThemeProvider } from 'styled-components';

import ErrorBoundary from './Components/ErrorBoundary';
import { GlobalStyleWrap } from './Components/GlobalStyle';
import { theme } from './Components/GlobalStyle/theme';
import Page from './Components/Page';
import Spinner from './Components/Splashes/Spinner';

// const Page = React.lazy(() => import('./Components/Page'));

const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyleWrap {...theme} />
    <ErrorBoundary>
      <React.Suspense fallback={<Spinner />}>
        <Page />
        {/* <Spinner /> */}
      </React.Suspense>
    </ErrorBoundary>
  </ThemeProvider>
);

export default App;
